import React, { FC } from 'react';

import {
  Stack,
  HStack,
  AccordionButton,
  Box,
  AccordionItem,
  Accordion,
  Center,
} from '@chakra-ui/react';
import { map } from 'lodash';
import { customTheme } from 'theme';

import { TriangleDownIcon } from 'components/Icons';
import { permissionStyles } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardAws/styles';

export const PermissionsForOnboarding: FC = () => {
  const permissionsMapping = [
    {
      label: 'Security Viewer',
      description: '',
    },
    {
      label: 'Viewer',
      description: '',
    },
  ];
  return (
    <Accordion allowMultiple>
      {map(permissionsMapping, o => (
        <AccordionItem border="none" key={o.label + '-permission'}>
          {({ isExpanded }) => (
            <>
              <AccordionButton {...permissionStyles.button} py={3}>
                <Stack textAlign="left">
                  <HStack color="primary">
                    <Center boxSize={6}>
                      <TriangleDownIcon />
                    </Center>
                    <Box {...permissionStyles.label}>{o?.label}</Box>
                  </HStack>
                  <Box pl={8} color={customTheme.colors.gray['250']}>
                    {o?.description}
                  </Box>
                </Stack>
              </AccordionButton>
            </>
          )}
        </AccordionItem>
      ))}
    </Accordion>
  );
};
